import React from 'react'

const AccordionHeader = ({
  onClick,
  title,
  icon,
  variableStyles,
}) => {
  return (
    <div
      style={{
        ...variableStyles,
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems:'center',
        cursor: "pointer",
      }}
      onClick={onClick}
    >
      {title} {icon}
    </div>
  );
};

export default AccordionHeader